import React from "react";
import TitanTuesdayBuilder from "./TitanTuesdayBuilder";

const TitanTuesday2026 = () => <TitanTuesdayBuilder contentKey="titanTuesday2026" />;

export default TitanTuesday2026;
